import ProductList from '@frontend/features/product-list/ProductList'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useParams } from 'react-router-dom'

function Content() {
  const { '*': categoryPath } = useParams()
  const parts = categoryPath?.split('/').filter(Boolean)
  const category = parts?.pop()

  let brand

  if (categoryPath?.includes('asava')) {
    brand = 'asava'
  }

  if (categoryPath?.includes('asv')) {
    brand = 'asv'
  }

  return (
    <ProductList
      brand={brand}
      category={category}
      showBrandFilter={false}
      showDiscountFilter={false}
      type="default"
    />
  )
}

export function ProductCategory() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default ProductCategory
